var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavRoomHistory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.88 9.985v6.727c0 .896-.719 1.621-1.603 1.621H4.056a1.612 1.612 0 01-1.602-1.62V9.984M5.667 7.672c0 1.038-.896 1.88-2 1.88-1.105 0-2-.842-2-1.88V6.46M13.666 7.672c0 1.038.896 1.88 2 1.88 1.106 0 2-.842 2-1.88V6.46M9.667 7.672c0 1.038-.895 1.88-2 1.88s-2-.842-2-1.88"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.667 7.672c0 1.038.895 1.88 2 1.88 1.104 0 2-.842 2-1.88M9.667 7.672c0 1.038.896 1.88 2 1.88s2-.842 2-1.88M9.667 1.667h6.003l1.298 3.126M9.667 1.667H3.664L1.74 6.296"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.657 1.667h6.003l1.923 4.63"
  })));
}
export default SvgNavRoomHistory;